import { render, staticRenderFns } from "./bfycg.vue?vue&type=template&id=50ab6b02&scoped=true"
import script from "./bfycg.vue?vue&type=script&lang=js"
export * from "./bfycg.vue?vue&type=script&lang=js"
import style0 from "./bfycg.vue?vue&type=style&index=0&id=50ab6b02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ab6b02",
  null
  
)

export default component.exports